module.exports = __webpack_public_path__ + "static/media/pg.32db955e.svg";